import { useEffect, useMemo, useState } from 'react';
import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import { useDispatch } from 'react-redux';

const classUtils = MojitoCore.Base.classUtils;
const { actions: betslipActions } = MojitoServices.Betslip;
const { FlexPane, Dropdown } = MojitoPresentation.Components;

const optionsTypeComparator = sortOrderMask => (t1, t2) =>
    sortOrderMask.indexOf(t1) - sortOrderMask.indexOf(t2);

const TeaserOptions = props => {
    const { mojitoTools, options: optionsMap, selectedTeaserType, class: className } = props;
    const { config, appContext, stringResolver } = mojitoTools;
    const dispatch = useDispatch();

    const optionItems = useMemo(() => {
        const compareByType = optionsTypeComparator(config.teaserTypesOrder);
        const getOptionLabel = option => `${appContext.sportName(option.sportId)} ${option.hcap}`;
        return Object.keys(optionsMap)
            .sort(compareByType)
            .map(teaserType => {
                const separator = stringResolver.resolveString('$TEASER_OPTIONS.SEPARATOR');
                const label = optionsMap[teaserType].map(getOptionLabel).join(separator);
                return { value: teaserType, label };
            });
    }, [optionsMap, appContext, stringResolver, config.teaserTypesOrder]);

    // Keep track of manually selected teaser type to avoid undesired selection reset in dropdown. It can happen due to client-server communication delay.
    const [manuallySelectedType, setManuallySelectedType] = useState();
    // Once server responds with new betslip, the updated selectedTeaserType will come as a prop.
    // At this point we can reset manuallySelectedType back to undefined.
    useEffect(() => setManuallySelectedType(undefined), [selectedTeaserType]);
    const onOptionChange = value => {
        setManuallySelectedType(value);
        dispatch(betslipActions.activateTeaserType(value));
    };
    return (
        <FlexPane
            config={config.container}
            class={classUtils.classNames('ta-TeaserOptions', className)}
        >
            <Dropdown
                items={optionItems}
                selectedItemValue={manuallySelectedType || selectedTeaserType}
                cbOnChange={onOptionChange}
                config={config.dropdown}
                triggerOverlayInteraction={false}
                class="ta-teaserOptionsDropdown"
            />
        </FlexPane>
    );
};

export default TeaserOptions;
